import { render, staticRenderFns } from "./WorkTaskSummary.vue?vue&type=template&id=10b35148"
import script from "./WorkTaskSummary.vue?vue&type=script&lang=ts"
export * from "./WorkTaskSummary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports